import { axiosInstance } from "../../../Utils/AxiosInstance";

export const NotificationSeenApi = async ({ loginId, unreadIds }) => {
  try {
    const response = await axiosInstance.put(
      `/Notifications/MarkAsRead?userId=${loginId}`,
      unreadIds,
    );
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
